<template>
  <div :class="$style.circled">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'CircledCharacter',
};
</script>

<style module scoped>
.circled {
  align-items: center;
  border: 2px solid;
  border-radius: 50%;
  display: flex;
  font-weight: bold;
  height: var(--jcHeadingSmall);
  justify-content: center;
  margin-top: 2px;
  width: var(--jcHeadingSmall);
}
</style>
